import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** The × glyph, 16px. The 14px mobile variant is the same glyph scaled down. */
export const SearchComboboxCloseIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={16} {...props}>
        <path d="M12 4L4 12" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 4L12 12" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** The × glyph, 16px. The 14px mobile variant is the same glyph scaled down. */
export const SearchComboboxCloseIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={16} {...props}>
        <path d="M12 4L4 12" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 4L12 12" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
